var classes = {"contentCard":"_0eu4F","portraitCard":"_6eHtF"};

export { classes as default };
